<template>
  <div>
    <!-- 用户信息部分（评论时间以及点赞） -->
    <div class="comment_info">
      <div class="time">{{num == null?"":num+"楼"}} {{ info.created_at }}</div>
      <div class="givLike">
        <div class="huifu" @click="childrenUpComment">回复</div>
        <div class="givLike_heng"></div>
        <div class="givLike_box">
          <giveLike :mygiveLike="info" :share_id="share_id"></giveLike>
        </div>
      </div>
    </div>
    <div class="edit_comment" v-if="commentStatus">
      <div class="edit_input_box">
        <div class="heihgt20">
          <span v-if="info.to_user_name">
            回复
            <span style="color: #2881b0">{{ info.to_user_name }}</span> ：
          </span>
          <span v-else>
            回复
            <span style="color: #2881b0">{{ info.username }}</span> ：
          </span>
          <input type="text" class="comment_input" v-model="text" />
          <!-- 提示内容框 -->
          <!-- <div class="pinglunBox">{{ conment_content }}</div> -->
        </div>
        <!-- <div class="heihgt20">
          <i class="iconfont icon-tupian1"></i>
        </div> -->
      </div>
      <div class="edit_input_btn" @click="openDialog">评论</div>
      <!-- <commentDiaLog
        :share_id="share_id"
        ref="mydialog"
        @MyClose="changeComment($event)"
      ></commentDiaLog> -->
    </div>
    <!-- <commentDiaLog
      :share_id="share_id"
      :myInfo="info"
      ref="mydialog"
    ></commentDiaLog> -->
  </div>
</template>

<script>
// import commentDiaLog from "../commentDialog.vue";
import { mapState } from "vuex";
import giveLike from "../giveLike.vue";
export default {
  name: "commentInfo",
  components: { giveLike },
  props: {
    // 楼层
    num: {
      type: Number,
      default: null,
    },
    info: {
      type: Object,
      default: () => {
        return {
          time: "1999.99.99(缺少时间)",
          praised_count: 99,
        };
      },
    },
    share_id: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      giveLikeInfo: null,
      // 评论区的内容
      text: "",
      // 评论组件是否显示的控件
      commentStatus: false,
    };
  },
  mounted() {},
  computed: {
    ...mapState(["token", "agency_id"]),
  },
  methods: {
    childrenUpComment() {
      // this.$refs.mydialog.open();
      this.commentStatus = !this.commentStatus;
    },
    openDialog() {
      // this.$refs.mydialog.open();
      this.UpComment();
    },
    // 上传评论
    UpComment() {
      let conmentValue = {};
      this.dialogFormVisible = false;
      if (this.towAndThree) {
        conmentValue = {
          token: this.token,
          agency_id: this.agency_id,
          // remark_id:5,
          share_id: this.share_id,
          content: this.text,
        };
      } else {
        // if (this.info.from_user_name == this.info.to_user_name) {
        //   this.$alert("自己不能回复自己噢~~~", "提示", {
        //     confirmButtonText: "确定",
        //   });
        //   return;
        // }
        conmentValue = {
          token: this.token,
          agency_id: this.agency_id,
          remark_id: this.info.reamrk_id,
          share_id: this.share_id,
          content: this.text,
        };
      }
      this.$axios
        .get("/pushRemark", {
          params: conmentValue,
        })
        .then((doc) => {
          if (doc.code == 200) {
            this.commentStatus = false;
            this.text = "";
            if (doc.level == 2) {
              this.$emit("twoaddcomment", doc);
            } else if (doc.level == 3) {
              this.$emit("addcomment", doc);
            }
          } else {
            this.$message(doc.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("评论发布失败");
        });
    },
  },
};
</script>

<style lang="less" scoped>
// 评论信息部分（时间、点赞）
.comment_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.6875rem 0;
  font-size: 0.75rem;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #909090;

  .givLike {
    display: flex;
    flex-direction: row;
    justify-items: center;
    align-items: center;
    .huifu {
      cursor: pointer;
    }
    .givLike_heng {
      margin: 0 0.625rem;
      width: 0.0625rem;
      height: 0.75rem;
      background: #d9d9d9;
    }
    .givLike_box {
      /deep/ .noActive {
        font-size: 0.75rem !important;
        font-family: "Microsoft YaHei";
        font-weight: 400 !important;
        color: #909090 !important;
      }
      /deep/ .img-box {
        font-size: 0.75rem !important;
        color: #909090 !important;
      }
      /deep/.icon-zan:before {
        color: #909090 !important;
      }
      /deep/.iconfont {
        font-size: 0.75rem !important;
      }
      // /deep/ .circle{
      //   width: .875rem;
      //   height: .875rem;
      // }
    }
  }

  // 评论部分
}

.edit_comment {
  padding: 0.6875rem;
  display: flex;
  flex-direction: row;
  justify-items: center;
  // align-items: center;

  .edit_input_box {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 1rem;
    padding: 0 0.625rem;
    height: 2.375rem;
    background: #ffffff;
    border: 0.0625rem solid #ebebeb;
    border-radius: 0.1875rem;
    .heihgt20 {
      height: auto;
      width: 100%;
      display: flex;
      flex-direction: row;
      span {
        flex-shrink: 0;
        font-size: 0.875rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #989fac;
        font: 400 0.833331rem Arial;
      }

      .comment_input {
        outline: none;
        border: none;
        width: 100%;
      }
      .pinglunBox {
        width: 28.125rem;
        font-size: 0.875rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #989fac;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .icon-tupian1 {
        font-size: 1.25rem;
        color: #98a2b4;
      }
    }
  }
  .edit_input_btn {
    cursor: pointer;
    width: 3.875rem;
    height: 2.375rem;
    background: #fa7d3c;
    border-radius: 0.1875rem;
    line-height: 2.375rem;
    text-align: center;
    font-size: 1rem;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
  }
}
</style>